/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRjovUHJvZ3JhbWFjaW9uL05vZGUvcHJveWVjdG9zL0FuZ3VsYXIyL21pcy1lamVtcGxvcy9Db2xvcmVzLUFuZ3VsYXI0LXJ1dGFzLWFuaWRhZGFzL3NyYy9hcHAvbm90LWZvdW5kL25vdC1mb3VuZC5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Y6L1Byb2dyYW1hY2lvbi9Ob2RlL3Byb3llY3Rvcy9Bbmd1bGFyMi9taXMtZWplbXBsb3MvQ29sb3Jlcy1Bbmd1bGFyNC1ydXRhcy1hbmlkYWRhcy9zcmMvYXBwL25vdC1mb3VuZC9ub3QtZm91bmQuY29tcG9uZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/not-found/not-found.component.css.shim.ngstyle.ts